import React, { useState, useEffect } from "react";
import { navigate } from "@reach/router"
import { Container, Row, Col, Form } from 'react-bootstrap'
import SearchResultInputBox from 'gatsby-theme-starberry-lomondgroup/src/components/SearchResult/SearchResultBox';
import {defaultArea_Slug, index_name, search_box_placeholder} from "gatsby-theme-starberry-lomondgroup/src/common/constant";
import "./PropertySearch.scss";

const PropertySearch = ({Module}) => {

    const[query, setQuery] = useState("");
    const[department, setDepartment] = useState("residential");

    const handleBuy = (e) => {
        e.preventDefault();
        let area_name = query ? query :  defaultArea_Slug;
        navigate(`/property/for-sale/in-${area_name}/`)
    }

    const handleRent = (e) => {
        e.preventDefault();
        let area_name = query ? query :  defaultArea_Slug;
        navigate(`/property/to-rent/in-${area_name}/`)
    }

    return (
        <React.Fragment>
            <section className="property-search-wrapper">
                <Container>
                    <Row>
                        <Col>
                            {Module.title && <h2>{Module.title}</h2>}
                            <div className="property-search-box d-flex justify-content-md-between align-items-md-center flex-wrap m-auto">
                                <SearchResultInputBox areaVal={query} placeHolder={search_box_placeholder || `Enter a location e.g. Edinburgh or EH1`} department={department} handleChange={setQuery} className="location_input"/>
                                <ul className="list-inline">
                                    <li className="list-inline-item">
                                        <a href="javascript:void(0)" className="btn btn-primary" onClick={handleBuy}>Buy</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="javascript:void(0)" className="btn btn-primary" onClick={handleRent}>Rent</a>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    )
}

export default PropertySearch